
export function FooterSection() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    solutions: [
      { name: 'Upstream Exploration', href: '#upstream-solutions' },
      { name: 'High-Tech Products', href: '#tech-solutions' },
      { name: 'Technology Consulting', href: '#consulting' },
      { name: 'Custom Development', href: '#development' }
    ],
    company: [
      { name: 'About Us', href: '#about' },
      { name: 'Global Presence', href: '#global' },
      { name: 'Core Advantages', href: '#advantages' },
      { name: 'Contact', href: '#contact' }
    ],
    regions: [
      { name: 'Middle East', href: '#middle-east' },
      { name: 'Asia-Pacific', href: '#asia-pacific' },
      { name: 'North America', href: '#north-america' },
      { name: 'Singapore HQ', href: '#singapore' }
    ]
  };

  return (
    <footer className="bg-gradient-to-b from-slate-900/80 to-black/90 border-t border-white/10">
      <div className="container mx-auto px-6 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <h3 
              className="text-2xl text-white tracking-wide mb-4 font-light"
              style={{ fontFamily: "'Share Tech', sans-serif" }}
            >
              Geosenture
            </h3>
            <p className="text-white/70 mb-6 leading-relaxed">
              Global energy technology partner providing AI-powered upstream exploration solutions and high-tech products worldwide.
            </p>
            <div className="text-white/60 text-sm">
              <p className="mb-2">
                <strong className="text-white/80">Geosenture Pte. Ltd.</strong>
              </p>
              <p className="leading-relaxed">
                10 ANSON ROAD, #26-03<br />
                INTERNATIONAL PLAZA<br />
                SINGAPORE 079903
              </p>
            </div>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="text-white font-semibold mb-6">Solutions</h4>
            <ul className="space-y-3">
              {footerLinks.solutions.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-6">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Global Presence */}
          <div>
            <h4 className="text-white font-semibold mb-6">Global Presence</h4>
            <ul className="space-y-3">
              {footerLinks.regions.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-white/60 text-sm">
              © {currentYear} Geosenture Pte. Ltd. All rights reserved.
            </div>
            
            <div className="flex items-center gap-6">
              <div className="text-white/60 text-sm">
                Connecting Energy • Technology • Future
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
